/*
  Add here your own custom javascript codes
*/

document.addEventListener('DOMContentLoaded', function () {
  const body = document.body
  // Navbar logo swap on scroll
  const navbarWrapper = document.getElementById('navbar-wrapper')
  const updateNavbarScrolledState = () => {
    if (!navbarWrapper) return
    // Add a small threshold to reduce jitter near the top while still
    // switching back only at the exact top.
    const threshold = 50
    if (window.scrollY > threshold) {
      navbarWrapper.classList.add('scrolled')
    } else if (window.scrollY === 0) {
      navbarWrapper.classList.remove('scrolled')
    }
  }
  updateNavbarScrolledState()
  window.addEventListener('scroll', updateNavbarScrolledState, { passive: true })
  window.addEventListener('load', updateNavbarScrolledState)

  // Social share handler (always open provider share URL in a popup)
  document.addEventListener('click', function (e) {
    const trigger = e.target.closest('a.js-share')
    if (!trigger) return

    e.preventDefault()

    const shareUrl = trigger.getAttribute('data-share-url') || window.location.href
    const shareTitle = trigger.getAttribute('data-share-title') || document.title
    const shareSummary = trigger.getAttribute('data-share-summary') || ''
    const network = (trigger.getAttribute('data-share-network') || '').toLowerCase()

    function buildShareHref () {
      const u = encodeURIComponent(shareUrl)
      const t = encodeURIComponent(shareTitle)
      const s = encodeURIComponent(shareSummary)
      switch (network) {
        case 'facebook':
          return `https://www.facebook.com/sharer/sharer.php?u=${u}`
        case 'twitter':
        case 'x':
          return `https://twitter.com/intent/tweet?url=${u}&text=${t}`
        case 'linkedin':
          return `https://www.linkedin.com/sharing/share-offsite/?url=${u}`
        default:
          return trigger.href || shareUrl
      }
    }

    function openPopup (href, name = 'share', w = 600, h = 600) {
      const dualScreenLeft = window.screenLeft !== undefined ? window.screenLeft : window.screenX
      const dualScreenTop = window.screenTop !== undefined ? window.screenTop : window.screenY
      const width = window.innerWidth || document.documentElement.clientWidth || screen.width
      const height = window.innerHeight || document.documentElement.clientHeight || screen.height
      const left = (width - w) / 2 + dualScreenLeft
      const top = (height - h) / 2 + dualScreenTop
      const features = `scrollbars=yes,width=${w},height=${h},top=${top},left=${left},noopener,noreferrer`
      const win = window.open(href, name, features)
      if (win && win.focus) win.focus()
    }

    openPopup(buildShareHref())
  })

  const navModal = document.getElementById('nav_modal')
  if (!navModal) return

  // Detect if the current device can hover (mouse/trackpad)
  const canHoverQuery = window.matchMedia('(hover: hover) and (pointer: fine)')
  const canHover = () => canHoverQuery.matches

  function selectFirstPanels () {
    navModal.querySelectorAll('.menu-fixed ul li').forEach(li => li.classList.remove('active'))
    navModal.querySelectorAll('.menu-wrapper').forEach(w => w.classList.remove('active'))

    const firstFixed = navModal.querySelector('.menu-fixed ul li')
    const firstWrapper = navModal.querySelector('.menu-wrapper')
    firstFixed?.classList.add('active')
    firstWrapper?.classList.add('active')

    navModal.querySelectorAll('.menu.menu-parent ul li').forEach(li => li.classList.remove('active'))
    navModal.querySelectorAll('.menu.menu-parent ul').forEach(ul => ul.classList.remove('active'))
    navModal.querySelectorAll('.menu.menu-child').forEach(mc => mc.classList.remove('active'))
  }

  function switchPanel (fixedId) {
    navModal.querySelectorAll('.menu-wrapper').forEach(w => w.classList.remove('active'))
    navModal.querySelector(`.menu-wrapper[data-id="${fixedId}"]`)?.classList.add('active')
  }

  function openSlideout (parentId) {
    navModal.querySelectorAll('.menu.menu-child').forEach(mc => mc.classList.remove('active'))
    navModal.querySelectorAll('.menu.menu-child .sub-menu').forEach(sm => sm.classList.remove('active'))
    const parentSub = navModal.querySelector(`.menu.menu-child .sub-menu[data-id="${parentId}"]`)
    parentSub?.parentElement?.classList.add('active')
    parentSub?.classList.add('active')
  }

  // Mobile detection similar to WP code
  function detectMobile () {
    if (window.innerWidth <= 992) body.classList.add('mobile')
    else body.classList.remove('mobile')
  }
  detectMobile()
  window.addEventListener('resize', detectMobile)

  // Hover/click behavior for parent items
  navModal.addEventListener('mouseover', function (e) {
    const li = e.target.closest('.menu.menu-parent ul li')
    if (!li) return
    // On devices flagged as mobile by width, still allow hover when the device actually supports it
    if (body.classList.contains('mobile') && !canHover()) return
    const parentId = li.getAttribute('data-id')
    navModal.querySelectorAll('.menu.menu-parent ul li').forEach(el => el.classList.remove('active'))
    if (li.classList.contains('menu-item-has-children')) li.classList.add('active')
    openSlideout(parentId)
  })

  // Desktop: within an active sub-menu, hovering a child with grand-children toggles their submenu
  navModal.addEventListener('mouseover', function (e) {
    if (body.classList.contains('mobile') && !canHover()) return
    const childItem = e.target.closest('.menu.menu-child .sub-menu > ul > li')
    if (!childItem) return
    const subMenu = childItem.closest('.sub-menu')
    // Remove active from sibling child items that may control a grandchild menu
    subMenu.querySelectorAll(':scope > ul > li').forEach(li => li.classList.remove('active'))
    childItem.classList.add('active')

    // Background now comes from parent-level metafield and is set inline via style attribute; nothing to do here
  })

  navModal.addEventListener('click', function (e) {
    // Fixed menu switch
    const fixedAnchor = e.target.closest('.menu-fixed ul li a')
    if (fixedAnchor) {
      e.preventDefault()
      const li = fixedAnchor.parentElement
      const fixedId = li.getAttribute('data-id')
      navModal.querySelectorAll('.menu-fixed ul li').forEach(el => el.classList.remove('active'))
      li.classList.add('active')
      switchPanel(fixedId)
      return
    }

    // Mobile parent open
    if (body.classList.contains('mobile')) {
      const parentAnchor = e.target.closest('.menu.menu-parent ul li a')
      if (parentAnchor) {
        const li = parentAnchor.parentElement
        const parentId = li.getAttribute('data-id')
        navModal.querySelectorAll('.menu.menu-parent ul li').forEach(el => el.classList.remove('active'))
        if (li.classList.contains('menu-item-has-children')) {
          li.closest('ul')?.classList.add('active')
          li.classList.add('active')
          e.preventDefault()
        }
        openSlideout(parentId)
        return
      }

      // Prevent navigation when item has children
      const hasChildrenAnchor = e.target.closest('.menu.menu-parent ul li.menu-item-has-children a')
      if (hasChildrenAnchor) {
        e.preventDefault()
        return
      }

      // Back button
      const backBtn = e.target.closest('.mobile-menu-back')
      if (backBtn) {
        e.preventDefault()
        navModal.querySelectorAll('.menu.menu-parent ul li').forEach(el => el.classList.remove('active'))
        navModal.querySelectorAll('.menu.menu-parent ul').forEach(ul => ul.classList.remove('active'))
        navModal.querySelectorAll('.menu.menu-child').forEach(mc => mc.classList.remove('active'))
        return
      }

      // Mobile: tap to toggle grandchild submenu within current sub-menu
      const childWithGrand = e.target.closest('.menu.menu-child .sub-menu > ul > li.menu-item-has-children > a')
      if (childWithGrand) {
        e.preventDefault()
        const li = childWithGrand.parentElement
        const subMenu = li.closest('.sub-menu')
        // Toggle active on tapped li; close others
        subMenu.querySelectorAll(':scope > ul > li.menu-item-has-children').forEach(sib => {
          if (sib !== li) sib.classList.remove('active')
        })
        li.classList.toggle('active')
        // Ensure the grandchild list is scrolled into view on mobile
        const gc = li.querySelector(':scope > ul.grandchild-menu')
        if (gc) {
          setTimeout(() => { gc.scrollIntoView({ block: 'nearest' }) }, 0)
        }
      }
    }
  })

  // When opening modal via desktop nav, ensure the clicked item is highlighted in the fixed tabs
  document.querySelectorAll('#primary_nav .nav-item > a[href="#nav_modal"]').forEach((a) => {
    a.addEventListener('click', (e) => {
      const li = a.closest('.nav-item')
      if (!li) return
      const fixedId = li.getAttribute('data-id')
      document.querySelectorAll('#primary_nav .nav-item').forEach(el => el.classList.remove('active'))
      li.classList.add('active')
      navModal.querySelectorAll('.menu-fixed ul li').forEach(el => el.classList.remove('active'))
      navModal.querySelector(`.menu-fixed ul li[data-id="${fixedId}"]`)?.classList.add('active')
      switchPanel(fixedId)
    })
  })

  // Reset panels on hide
  navModal.addEventListener('hidden.bs.modal', function () {
    selectFirstPanels()
  })

  // Open modal from any anchor targeting #nav_modal
  document.querySelectorAll('a[href="#nav_modal"]').forEach((anchor) => {
    anchor.addEventListener('click', function (e) {
      e.preventDefault()
      const modal = window.bootstrap ? window.bootstrap.Modal.getOrCreateInstance(navModal, { backdrop: false, keyboard: true }) : null
      modal?.show()

      // If clicked from a primary nav item, switch to corresponding fixed panel
      const li = anchor.closest('#primary_nav .nav-item')
      if (li) {
        const fixedId = li.getAttribute('data-id')
        navModal.querySelectorAll('.menu-fixed ul li').forEach(el => el.classList.remove('active'))
        navModal.querySelector(`.menu-fixed ul li[data-id="${fixedId}"]`)?.classList.add('active')
        switchPanel(fixedId)
      } else {
        // Otherwise reset to first panels
        selectFirstPanels()
      }
    })
  })

  // Click outside of modal closes it (since backdrop is disabled)
  document.addEventListener('click', function (e) {
    if (!navModal.classList.contains('show')) return
    const clickedInsideModal = e.target.closest('#nav_modal .modal-content')
    const clickedTrigger = e.target.closest('a[href="#nav_modal"]')
    if (!clickedInsideModal && !clickedTrigger) {
      const modal = window.bootstrap ? window.bootstrap.Modal.getOrCreateInstance(navModal, { backdrop: false }) : null
      modal?.hide()
    }
  })

  // ESC key closes modal (keep this behavior)
  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape') {
      const modal = window.bootstrap ? window.bootstrap.Modal.getOrCreateInstance(navModal, { backdrop: false }) : null
      modal?.hide()
    }
  })

  // Search Modal functionality
  const searchModal = document.getElementById('search_modal')
  if (searchModal) {
    // Initialize modal with no backdrop
    const searchModalInstance = window.bootstrap ? window.bootstrap.Modal.getOrCreateInstance(searchModal, { 
      backdrop: false,
      keyboard: true 
    }) : null

    // Handle search icon click
    const searchTrigger = document.getElementById('search-modal-trigger')
    if (searchTrigger && searchModalInstance) {
      searchTrigger.addEventListener('click', function (e) {
        e.preventDefault()
        searchModalInstance.show()
      })
    }

    // Focus input when modal opens
    searchModal.addEventListener('shown.bs.modal', function () {
      const searchInput = searchModal.querySelector('#search_modal_input')
      if (searchInput) {
        searchInput.focus()
      }
    })

    // ESC key closes search modal
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && searchModal.classList.contains('show')) {
        searchModalInstance?.hide()
      }
    })

    // Click outside modal content closes it
    searchModal.addEventListener('click', function (e) {
      if (e.target === searchModal) {
        searchModalInstance?.hide()
      }
    })

    // Animated underline effect (delegated to navbar.liquid logic)
    const searchInput = searchModal.querySelector('#search_modal_input')
    const searchUnderline = searchModal.querySelector('#search_modal_underline')
    
    if (searchInput && searchUnderline) {
      // Do not force full-width on focus; width is controlled by input text measurement
      searchInput.addEventListener('blur', function () {
        if (!searchInput.value.trim()) {
          searchUnderline.style.width = '0'
          searchUnderline.classList.remove('is-active')
        }
      })
    }
  }
})

